import { FeatureContext } from "@/modules/common/components/layout/side-menu/old-navbar/feature.context";
import { useContext, useEffect, useState } from "react";

const FeatureRouter = ({
  featureKey,
  element,
  elseElement = null,
}: {
  featureKey: string;
  element: any;
  elseElement?: any;
}) => {
  const {
    configs,
  }: {
    configs: any;
  } = useContext(FeatureContext);
  const [renderElement, setRenderElement] = useState(null);

  const featureControl = () => {
    if (configs) {
      if (
        configs[featureKey] ||
        configs[featureKey] === undefined ||
        configs[featureKey] == null
      )
        setRenderElement(element);
      else setRenderElement(elseElement);
    }
  };

  useEffect(() => {
    featureControl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configs]);

  return renderElement;
};

export default FeatureRouter;
